<template>
  <div id="data-list-list-view" class="data-list-container">

    <data-view-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData" />

    <vs-table ref="table" pagination :max-items="itemsPerPage" search :data="payslips">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center data-list-btn-container">

          <!-- ACTION - DROPDOWN -->

          <!-- ADD NEW -->
            <h2 class="text-xl font-semibold mb-2">Upload a file</h2>
            <div
              class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary">
              <feather-icon icon="UploadIcon" svgClasses="h-4 w-4" />
              <input type="file" @change="handleFileUpload" />
            </div>
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ payslips.length - currentPage
              * itemsPerPage > 0 ? currentPage * itemsPerPage : payslips.length }} of {{ queriedItems }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage = 5">
              <span>5</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 20">
              <span>20</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 50">
              <span>50</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 100">
              <span>100</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="category">Date</vs-th>
        <vs-th sort-key="name">XLS TITLE</vs-th>
        <vs-th sort-key="category">XLS FILE</vs-th>
        <vs-th>Action</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="font-medium truncate">{{ format_date(tr.createdAt, false) }}</p>
            </vs-td>
            <vs-td>
              <p>{{ tr.title }}</p>
            </vs-td>
            <vs-td>
              <p>{{ tr.filename }}</p>
            </vs-td>

            <vs-td class="whitespace-no-wrap">

              <feather-icon icon="EyeIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"
                @click.stop="OpenPayslips(tr.id)" />
            </vs-td>

          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
import moduleDataListPayslip from '@/store/payslip/moduleDataList.js'
import axios from "@/axios.js";
import moment from "moment"


export default {
  data() {
    return {
      displayinactive: false,
      isadmin: false,
      selected: [],
      itemsPerPage: 1000,
      isMounted: false,
      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {}
    }
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    payslips() {
      return this.$store.state.dataListPayslip.payslips
    },
    queriedItems() {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.payslips.length
    }
  },
  methods: {
    OpenPayslips(id) {
      window.location.replace("/web/payslipsender/" + id);
    },
    format_date(value, withhour) {
      if (value) {
        if (withhour)
          return moment(String(value)).format("DD MMM YYYY HH:mm:ss");
        else return moment(String(value)).format("DD MMM YYYY");
      }
    },
    async handleFileUpload(event) {
      const file = event.target.files[0];
      const formData = new FormData();
      formData.append("file", file);

      try {
        const response = await axios.post("/clicksend/uploadfluturas", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        console.log("File uploaded successfully", response.data);
        // Rechargez la page ou affichez une notification de succès
        window.location.reload();
      } catch (error) {
        // Vérifiez si le backend a renvoyé une réponse avec des détails
        if (error.response && error.response.data) {
          const errorMessage = error.response.data.message || "An error occurred.";
          const errorDetails = error.response.data.details || "";

          console.error("Error uploading file:", errorMessage, errorDetails);

          // Affichez une notification d'erreur à l'utilisateur
          this.$vs.notify({
            title: "Error Uploading File",
            text: `${errorMessage}${errorDetails ? " - " + errorDetails : ""}`,
            color: "danger",
            time: 8000,
          });
        } else {
          console.error("Unexpected error uploading file", error);
          // Affichez une notification générique pour les erreurs inattendues
          this.$vs.notify({
            title: "Unexpected Error",
            text: "Something went wrong while uploading the file. Please try again later.",
            color: "danger",
            time: 8000,
          });
        }
      }
    },
    getActiveColors(status) {
      if (status >= 0) return 'primary'
      if (status < 0) return 'danger'
      return 'black'
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val
    }
  },
  created() {
    if (localStorage.getItem("login-roles").toLowerCase().includes("admin") || localStorage.getItem("login-roles").toLowerCase().includes("moderator")) {
      this.isadmin = true
      if (!moduleDataListPayslip.isRegistered) {
        this.$store.registerModule('dataListPayslip', moduleDataListPayslip)
        moduleDataListPayslip.isRegistered = true
      }
      this.$store.dispatch('dataListPayslip/fetchPayslip')
    }
    else {
      this.$vs.notify({
        title: "Denied",
        text: "Access to the this page is reserved for administrators",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger",
        position: "bottom-right",
        time: 8000,
      });
      this.$router.push({ path: "/dashboard/analytics" });
    }
  },
  mounted() {
    this.isMounted = true
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      >span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, .05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: .5rem;
            border-bottom-left-radius: .5rem;
          }

          &:last-child {
            border-top-right-radius: .5rem;
            border-bottom-right-radius: .5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
